import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSettings } from 'services/settings/SettingsContext';
import { useTotalMrr } from './useAdminStatus';

interface TotalMrrWidgetProps {
    viewerToken?: string;
}

const TotalMrrWidget: React.FC<TotalMrrWidgetProps> = ({ viewerToken }) => {
    const { t } = useTranslation();
    const { userLocale } = useSettings();
    const { totalMrr, loading } = useTotalMrr(viewerToken);

    // Format the total mrr with the locale of the user
    const formatted = new Intl.NumberFormat(userLocale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(totalMrr);

    return (
        <div className='dashboard-card admin-status-widget'>
            <div className='admin-status-header'>
                <h6 className='title'>{t('dashboard.widget.total_mrr.title')}</h6>
            </div>
            {loading ? (
                <div className='admin-status-loading'><div className='loader' /></div>
            ) : (
                <div className='admin-status-body'>
                    <div className='admin-status-value'>€ {formatted}</div>
                </div>
            )}
        </div>
    );
};

export default TotalMrrWidget;
